module.exports = __webpack_public_path__ + "img/reporting_indavidual.8c36efc2.svg";